// extracted by mini-css-extract-plugin
export default {"cls1":"ResetPasswordForm-Form_cls1__uJN2+","cls2":"ResetPasswordForm-Form_cls2__Iek2D ResetPasswordForm-Form_cls1__uJN2+","offsetTop":"ResetPasswordForm-Form_offsetTop__U2VIN"};